export const getFormattedCounterText = (currentLength, maxLength) => {
  const maxLengthFormatted = (maxLength || '') && "/".concat(maxLength);
  return "".concat(currentLength).concat(maxLengthFormatted);
};